import {Component, Input, OnChanges} from '@angular/core';
import {NavItem} from '../../../../../../models/nav-item.model';
import {NavService} from '../../../../../../services/nav.service';
import {NavItemCodes} from '../../../../../../enums/nav-item-codes.enum';

@Component({
    selector: 'app-card-header',
    templateUrl: './card-header.component.html',
    styleUrls: ['./card-header.component.less']
})
export class CardHeaderComponent implements OnChanges {
    @Input() code: NavItemCodes | string;
    @Input() header: string;
    @Input() subheader: string;
    @Input() navItems: NavItem[] = [];
    @Input() payload: any;
    item: NavItem;

    ngOnChanges() {
        this.item = this.code ? NavService.get(this.code) : null;
    }
}
